import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerService {
  public isVisible: Subject<boolean> = new Subject();

  public show(): void {
    this.isVisible.next(true);
  }

  public hide(): void {
    this.isVisible.next(false);
  }
}
